@let logo = store.logoSg();
@let logoHovered = store.logoHoveredSg();
@let expanded = store.expandedSg();
@let pinned = store.pinnedSg();
@let currentZone = store.currentZoneSg();
@let isNotInTenant = store.isNotInTenantSg();
@let shouldShowMenuIcon = shouldShowMenuIconSg();

<div
  class="atn-navbar-logo"
  (mouseenter)="store.logoHoverStart()"
  (mouseleave)="store.logoHoverEnd()"
  data-test-id="atn-navbar-logo"
>
  <div
    class="atn-navbar-logo__img-container"
    [class.atn-navbar-logo__img-container--cutoff]="logoHovered"
  >
    <img
      class="atn-navbar-logo__img atn-navbar-logo__img--collapsed"
      [class.hidden]="expanded"
      [src]="logo.collapsed.src"
      [alt]="logo.collapsed.alt"
    />
    <img
      class="atn-navbar-logo__img atn-navbar-logo__img--expanded"
      [class.hidden]="!expanded"
      [src]="logo.expanded.src"
      [alt]="logo.expanded.alt"
    />
  </div>

  @if (currentZone) {
    <div
      class="atn-navbar-logo__zone"
      [class.hidden]="isNotInTenant || logoHovered || !expanded"
    >
      {{ currentZone.code }}
    </div>
  }

  <div
    class="atn-navbar-logo__icons"
    [class.hidden]="!logoHovered"
  >
    <i
      class="atn-navbar-logo__icon atn-icon atn-angle-{{
        pinned ? 'left' : 'right'
      }} atn-light"
      (click)="store.togglePin()"
    ></i>
    @if (shouldShowMenuIcon) {
      <i
        #logoMenuOpenerIcon
        class="atn-navbar-logo__icon atn-icon atn-overflow atn-light"
        (click)="store.toggleLogoMenuOpen()"
        data-test-id="nav-bar-options"
      ></i>
      <atn-navbar-logo-menu [origin]="logoMenuOpenerIcon" />
    }
  </div>
</div>
